import React, { Component } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Colors } from '../theme'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import RBButton from '../controls/RBButton'
import { localize } from '../util/Localizer'

class QuestionLink extends Component {
  constructor () {
    super()
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.state = {
      open: false
    }
  }

  handleOpen () {
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
  }

  render () {
    const { classes = {} } = this.props
    return (
      <div className={classnames(classes.textStyles, this.props.className)}>
        <div onClick={this.handleOpen} className={classes.icon}>?</div>
        <p onClick={this.handleOpen} className={classes.margin}>{this.props.title}</p>
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="simple-dialog-title"
          open={this.state.open}
          disableBackdropClick={true}
        >
          <DialogTitle id="simple-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            {this.props.content}
          </DialogContent>
          <DialogActions>
            <RBButton
              variant='outlined'
              key='close'
              label={localize('common.close')}
              primary={false}
              onClick={this.handleClose}
            />
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

QuestionLink.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired
}

const Styles = {
  textStyles: {
    display: 'flex',
    color: Colors.Palette.primaryColor,
    fontSize: '0.9rem',
    fontWeight: 'initial',
    cursor: 'pointer',
    textAlign: 'left'
  },
  icon: {
    background: Colors.Palette.primaryColor,
    width: 18,
    height: 18,
    fontSize: 16,
    color: 'white',
    textAlign: 'center',
    borderRadius: '50%',
    margin: '0 5px 0 0',
    fontWeight: 400
  },
  margin: { margin: 0, width: 'calc(100% - 23px)' }
}

export default withStyles(Styles)(QuestionLink)



// WEBPACK FOOTER //
// ./src/controls/QuestionLink.js